<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import upprocess from "../../../../common/upProcess/index.vue";
import uploadFile from "../../../../common/uploadFile/index.vue";
import updateywkm from "../../../../common/updateywkm/index.vue";
import {xxzzs_upload} from "../../../../../api/xxzzs.js";
import config from "../../../../../../configHttp.js";

export default {
  components: {
    upprocess,
    uploadFile,
    updateywkm,
  },
  data: function () {
    return {
      uptype: 1,
      importType: "0",
      mboptions: getdata().mboptions,
      count: 5,
      successdata: {successCount: 0, errorCount: 0},
      batchNum: "",
      upformdata: {}, //文件信息
    };
  },
  methods: {
    forbackup() {
      this.$refs["uploadfileRef"].forrefresh();
      this.uptype = 1;

      clearInterval(this.timer);
    },
    forchooseindex(index) {
      this.$emit("forchooseindex", index);
    },
    toCustomTemplate() {
      this.$router.push("/CustomTemplate");
    },
    getuploadparams(e) {
      this.upformdata = e;
      // 获取到的文件信息
    },
    fordownloadmb() {
      let params = {
        downUrl: config.baseURL + "oinv/template/download",
        typeObj: {
          toForm: false,
          fileName: "销项增值税明细表导入模板",
          fileType: "xlsx",
          failUrl: this.$winURl
        },
      };
      this.$downloadcommon(params);
    },
    importIinvExcel() {
      this.count = 5;
      if (this.$emptyandnull(this.upformdata.upfile)) {
        this.$message.error("请选择要上传的文件");
        return false;
      }

      let formData = {
        importType: this.importType,
        file: this.upformdata.upfile,
      };
      xxzzs_upload(formData).then((res) => {
        if (res.data.code == 1) {
          //如果成功数量为0则跳转至结果页面
          if (res.data.data.successCount == 0 || !res.data.data.successCount) {
            this.$message.error(
                "当前导入文件成功条数为0，具体错误信息可到上传结果界面查看"
            );
          } else {
            this.uptype = 2;
            this.batchNum = res.data.data.batchNo;
            this.successdata = {
              successCount: res.data.data.successCount,
              errorCount: res.data.data.errorCount,
            };
            this.timer = setInterval(() => {
              this.count--;
              if (self._isDestroyed) {
                clearInterval(this.timer);
                return false;
              }
              if (this.count == 0) {
                this.$refs["uploadfileRef"].forrefresh();
                this.uptype = 1;
                clearInterval(this.timer);
              }
            }, 1000);
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
